/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

import { createIllustration } from '@jira/illustrations__illustration/src/ui/index.tsx';
import type {
	AsImgProps,
	IllustrationFn,
	SVGViewBox,
} from '@jira/illustrations__illustration/src/ui/types.tsx';
import srcDark from '../../assets/people-and-tasks.svg'; // eslint-disable-line jira/import/no-duplicates
import srcLight from '../../assets/people-and-tasks.svg';

const Illustration: IllustrationFn<AsImgProps> = createIllustration({
	srcLight,
	srcDark,
});

export default Illustration;

// for advanced use only
const viewBox: SVGViewBox = [0, 0, 130, 122];
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { srcLight, srcDark, viewBox };
